import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Row, Col } from '@saucelabs/sl-component-grid';
import { Loader } from '@saucelabs/sl-component-loader';
import { records as jobsRecords } from '@saucelabs/sl-module-jobs';

import { selectors } from './../ducks/flatHeadlessJobs';
import AutomatedJobsEmptyState from './EmptyState/AutomatedJobsEmptyState';
import AutomatedJobs from './AutomatedJobs';
import AutomatedJobsFilters from './AutomatedJobsFilters';
import Styles from './../containers/JobsContainer.styles';

const HeadlessJobsTab = ({
  automated,
  automatedLoading,
  clearStatuses,
  filtersInitialized,
  isOpenSauceUser,
  noFilters,
  owners,
  ownership,
  selectOwner,
  showOwnersFilter,
  showSeeAllButton,
  status,
  trackedToggleStatus,
  username,
}) => (
  <div>
    <Row>
      <Col
        className={Styles['status-filter']}
        sm
      >
        {filtersInitialized ? (
          <AutomatedJobsFilters
            clearStatuses={clearStatuses}
            owners={owners}
            ownership={ownership}
            selectOwner={selectOwner}
            showOwnersFilter={showOwnersFilter}
            status={status}
            toggleStatus={trackedToggleStatus}
            username={username}
          />
        ) : null}
      </Col>
    </Row>
    <Loader
      className={Styles.loader}
      fontSize={3}
      show={automatedLoading}
    >
      {automated.size === 0 && noFilters && !isOpenSauceUser ? (
        <AutomatedJobsEmptyState />
      ) : (
        <AutomatedJobs
          isOpenSauceUser={isOpenSauceUser}
          jobs={automated}
          showSeeAllButton={showSeeAllButton}
        />
      )}
    </Loader>
  </div>
);

HeadlessJobsTab.propTypes = {
  automated: ImmutablePropTypes.listOf(
    ImmutablePropTypes.recordOf(jobsRecords.JobRecordClass).isRequired,
  ).isRequired,
  automatedLoading: PropTypes.bool.isRequired,
  clearStatuses: PropTypes.func.isRequired,
  filtersInitialized: PropTypes.bool.isRequired,
  isOpenSauceUser: PropTypes.bool.isRequired,
  noFilters: PropTypes.bool.isRequired,
  owners: PropTypes.array.isRequired,
  ownership: PropTypes.object.isRequired,
  selectOwner: PropTypes.func.isRequired,
  showOwnersFilter: PropTypes.bool.isRequired,
  showSeeAllButton: PropTypes.bool.isRequired,
  status: ImmutablePropTypes.list.isRequired,
  trackedToggleStatus: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
};

export default connect(
  selectors.headlessJobsSelector,
)(HeadlessJobsTab);
export {
  HeadlessJobsTab,
};
